import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-internal-contact-dialog.controller';
import template from './edit-internal-contact-dialog.html';
import userEmailMessagesTpl from './messages/user.email.messages.html';
import userNameMessagesTpl from './messages/user.name.messages.html';
import userPhoneMessagesTpl from './messages/user.phone.messages.html';

class dialogService {
  getOptions($event, { user }) {
    return {
      controller,
      controllerAs: 'editInternalContactDialogVM',
      locals: {
        user,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editInternalContactDialog', [
  loaderService,
  alerts,
  ssDialogService,
  orgDataService,
])
  .service('editInternalContactDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('user.email.messages.html', userEmailMessagesTpl);
    $templateCache.put('user.name.messages.html', userNameMessagesTpl);
    $templateCache.put('user.phone.messages.html', userPhoneMessagesTpl);
  })
  .name;
